var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.808 47.955L43.967 37.12a21.979 21.979 0 005.726-14.848C49.693 10 39.615 0 27.246 0 14.878 0 4.8 9.924 4.8 22.273 4.8 34.62 14.878 44.62 27.246 44.62c5.803 0 10.995-2.197 14.965-5.757L53.052 49.62c.23.227.535.379.84.379.305 0 .61-.152.84-.379.61-.454.61-1.212.076-1.666zm-27.562-5.91c-10.994 0-20.003-8.939-20.003-19.848 0-10.91 9.01-19.773 20.003-19.773 11.071 0 20.004 8.94 20.004 19.849s-9.01 19.772-20.004 19.772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.989 26.316l1.865-5.22 1.864 5.22h.701l2.645-7.216v-.052h-1.216L16.97 24.36l-1.839-5.312h-.555l-1.838 5.312-1.878-5.312H9.643v.052l2.645 7.216h.701zm10.99 0l1.864-5.22 1.865 5.22h.7l2.646-7.216v-.052h-1.217l-1.878 5.312-1.838-5.312h-.556l-1.838 5.312-1.878-5.312h-1.216v.052l2.645 7.216h.7zm10.989 0l1.865-5.22 1.864 5.22h.701l2.645-7.216v-.052h-1.217L38.95 24.36l-1.839-5.312h-.555l-1.838 5.312-1.878-5.312h-1.217v.052l2.645 7.216h.7z"
  }))));
}

export default SvgStockIcon;